import { Typography } from "@stardust-ds/react"

import styles from "./index.module.scss"
import CardUsers from "../../atoms/CardUsers"
import RcmpCardEllipsis from "../../atoms/Ellipsis"
import DocumentReadyIcon from "../../../assets/icons/DocumentReadyIcon"
import EditIcon from "../../../assets/icons/EditIcon"
import TrashIcon from "../../../assets/icons/TrashIcon"
import MoveIcon from "../../../assets/icons/MoveIcon"
import EyeIcon from "../../../assets/icons/EyeIcon"
import ExportIcon from "../../../assets/icons/ExportIcon"
import intl from "react-intl-universal"
import CopyIcon from "../../../assets/icons/CopyIcon"
import { fnCanExportBoard } from "../../../utils/verifyPermitions"

function RcmpTelemetryCard(props) {
  const { nData, cDescription, cColor, ...oRest } = props

  return (
    <div className={styles.telemetryCardContainer} {...oRest}>
      <p className={styles.data} style={{ color: cColor }}>
        {nData || 0}
      </p>
      <p className={styles.description}>{cDescription}</p>
    </div>
  )
}

function RcmpTelemetryCards(props) {
  const { aTelemetry } = props

  if (!aTelemetry?.length) return null

  return (
    <div className={styles.telemetryCardsContainer}>
      {aTelemetry.map((i, index) => (
        <RcmpTelemetryCard
          key={index}
          cData={i.data}
          cDescription={i.description}
          cColor={i.color}
          {...i}
        />
      ))}
    </div>
  )
}

export default function RcmpCardBoard(props) {
  const {
    oBoard,
    bReadOnly,
    cReadOnlyMessage,
    fnSetBDelete,
    fnSetNCardId,
    fnSetBOpenInteractions,
    fetchBordData,
    fnSetBisMove,
    onClick,
    fnCanChange,
    bIsResponsible,
    fnSetBDuplicateBoard,
    fnSetBiSOpenModalExport,
    fnSetBoard,
    ...oRest
  } = props

  if (!oBoard) return null

  const handleDelete = () => {
    fnSetBDelete(oBoard)
    fnSetNCardId(oBoard.id, oBoard.name)
  }

  const fnOpenModalInteractions = () => {
    fnSetBOpenInteractions(true)
    fnSetNCardId(oBoard.id)
  }
  const fnHandleEdit = () => {
    fnSetNCardId(oBoard.id)
    fetchBordData(oBoard.id)
  }

  function fnHandleMoveBoard() {
    fnSetNCardId(oBoard.id, oBoard.name)
    fnSetBisMove(true)
  }

  function fnHandleOnClick(e) {
    e.stopPropagation()
    onClick?.(oBoard)
  }

  function fnOpenModalDuplicateBoard() {
    fnSetBDuplicateBoard(oBoard)
    return
  }

  function fnOpenModalExport() {
    fnSetBiSOpenModalExport(true)
    fnSetBoard(oBoard)
  }

  const aActivitiesTelemetry = [
    {
      nData: oBoard?.total_pending,
      cDescription: intl.get("CardBoard.pendding_activities"),
      cColor: "#6CB6E3",
    },
    {
      nData: oBoard?.total_done,
      cDescription: intl.get("CardBoard.completed_activities"),
      cColor: "#1ECB4F",
    },
    {
      nData: oBoard?.total_delayed,
      cDescription: intl.get("CardBoard.overdue_activities"),
      cColor: "#E57E1E",
    },
    {
      nData: oBoard?.total,
      cDescription: intl.get("CardBoard.total_linked_activities"),
      cColor: "#415364",
    },
  ]

  const aCardOptions = [
    {
      label: intl.get("CardBoard.edit_board"),
      icon: <EditIcon />,
      onClick: fnHandleEdit,
    },
    {
      label: intl.get("CardBoard.duplicate_board"),
      icon: <CopyIcon fill={"none"} className={styles.duplicateIcon} />,
      onClick: fnOpenModalDuplicateBoard,
    },
    {
      label: intl.get("CardBoard.interactions"),
      icon: <DocumentReadyIcon width={26} height={22} />,
      onClick: fnOpenModalInteractions,
    },
    {
      label: intl.get("CardBoard.move_board"),
      icon: <MoveIcon />,
      onClick: fnHandleMoveBoard,
    },
    {
      label: intl.get("CardBoard.delete_board"),
      icon: <TrashIcon />,
      onClick: handleDelete,
    },
    // aplicar validacao para label abaixo apenas mostrar p adm master
  ]

  if (fnCanExportBoard()) {
    aCardOptions.push({
      label: intl.get("CardBoard.export_board"),
      icon: <ExportIcon />,
      onClick: fnOpenModalExport,
    })
  }
  const cContainerClasses = `${styles.cardsContainer} ${
    bReadOnly ? styles.cardsContaienrReadOnly : ""
  }`

  return (
    <>
      <div className={cContainerClasses} onClick={fnHandleOnClick} {...oRest}>
        <div className={styles.cardHeader}>
          <div className={styles.headerText}>
            {bReadOnly && (
              <div className={styles.readOnlyContainer}>
                <EyeIcon fill="#fff" />
                {cReadOnlyMessage && (
                  <div className={styles.readOnlyMessage}>{cReadOnlyMessage}</div>
                )}
              </div>
            )}
            <Typography type="h3" className="highlightFilterText">
              {oBoard.name}
            </Typography>
          </div>
          {!bReadOnly && bIsResponsible && (
            <RcmpCardEllipsis size={"180px"} aOptions={aCardOptions} />
          )}
        </div>
        <div className={styles.cardContent}>
          <CardUsers
            cLabel={intl.get("CardBoard.responsibles")}
            aUsers={oBoard?.responsibles}
          />
          <CardUsers
            cLabel={intl.get("CardBoard.observers")}
            aUsers={oBoard?.observers}
            bLarge
          />
          <RcmpTelemetryCards aTelemetry={aActivitiesTelemetry} />
        </div>
      </div>
    </>
  )
}
